import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { InstrumentType } from '@zero/shared/util-models';
import { FamousIndication } from 'constants/shared-constants';
import { homeActions } from '../+state/home.actions';
import { homeFeature } from '../+state/home.reducers';

@Injectable({ providedIn: 'root' })
export class HomeFacade {
  readonly #store = inject(Store);

  public readonly indications$ = this.#store.select(homeFeature.selectIndications);
  public readonly indicationsLoading$ = this.#store.select(homeFeature.selectIndicationsLoading);
  public readonly mostTradedStocks$ = this.#store.select(homeFeature.selectTopInstrumentsByType(InstrumentType.Share));
  public readonly mostTradedETFs$ = this.#store.select(homeFeature.selectTopInstrumentsByType(InstrumentType.Etf));
  public readonly mostTradedFonds$ = this.#store.select(homeFeature.selectTopInstrumentsByType(InstrumentType.Funds));
  public readonly mostTradedCryptos$ = this.#store.select(homeFeature.selectTopInstrumentsByType(InstrumentType.Crypto));
  public readonly mostTradedInstrumentsLoading$ = this.#store.select(homeFeature.selectMostTradedInstrumentsLoading);
  public readonly mostTradedDerivatives$ = this.#store.select(homeFeature.selectTopInstrumentsByType(InstrumentType.Derivative));

  public loadIndications(famousIndications: FamousIndication[]) {
    this.#store.dispatch(homeActions.setFamousIndications({ indications: famousIndications }));
  }

  public subscribeToIndicationQuotes() {
    this.#store.dispatch(homeActions.subscribeToIndicationQuotes());
  }

  public unsubscribeFromIndicesQuotes() {
    this.#store.dispatch(homeActions.unsubscribeFromIndicationQuotes());
  }

  public loadTopInstruments() {
    this.#store.dispatch(homeActions.loadTopInstruments());
  }

  public subscribeToTopTradesQuotes() {
    this.#store.dispatch(homeActions.subscribeToTopInstrumentsQuotes());
  }

  public unsubscribeFromTopTradesQuotes() {
    this.#store.dispatch(homeActions.unsubscribeFromTopInstrumentsQuotes());
  }
}
